// extracted by mini-css-extract-plugin
export default {"bold":"styles__bold___+F58s","container":"styles__container___aKj59"};